import React from 'react'
import { FormattedMessage } from 'react-intl'
import { LearnMore } from 'src/constants/trackingEvents'
import AdditionalInfo from 'src/Components/shared/AdditionalInfo'
import { Button, Panel, Format, If, Text } from 'src/Components'
import Questions from 'src/Components/shared/Questions/QuestionsContainer'
import RefiPoint from './RefiPoint'
import RefiRequest from './RefiRequest'
import { QUESTIONS } from 'src/constants/messages'
import RefiHeading from 'src/Components/shared/RefiHeading'

import styles from './Refinance.module.scss'

const refiTerms = [15, 'custom', 20, 25, 30]

const Refinance = ({
  withCurrentHomeData,
  refiStatus,
  rates,
  loans,
  interestTotal,
  companyName,
  showInfo,
  toggleInfo,
  intl
}) => (
  <div className={styles.container}>
    <RefiHeading
      paragraph={false}
      className={styles.heading}
      isFha={!!refiStatus.fha}
      isConsolidation={refiStatus.isConsolidation}
    />
    <Text size='s' element='h5' color='quiet'>
      <If condition={rates.length}>
        <FormattedMessage
          id='Homeowner.interest.refiSubheadline.withRates'
          defaultMessage='Based on our current rate trends:'
        />
      </If>
      <If condition={!rates.length}>
        <FormattedMessage
          id='Homeowner.interest.refiSubheadline.withoutRates'
          defaultMessage='Based on current national rate trends:'
        />
      </If>
    </Text>
    <div className={styles.columnGroup}>
      {refiTerms.map(term => (
        <If key={term} condition={refiStatus[term]}>
          <Panel className={styles.column}>
            <RefiPoint term={term} />
          </Panel>
        </If>
      ))}
    </div>
    <Button
      className={styles.infoButton}
      onClick={toggleInfo}
      track={LearnMore}
      trackEnabled={!showInfo}
      trackOptions={{ eventLabel: 'Interest-Refi' }}
    >
      <FormattedMessage
        id='Homeowner.interest.refinanceInfo.showInfo'
        defaultMessage='Learn more about this'
      />
    </Button>
    <AdditionalInfo visible={showInfo} cardWidth>
      <AdditionalInfo.Heading>
        <FormattedMessage
          id='Homeowner.interest.refinanceInfo.headline'
          defaultMessage='Refinancing can really save in the long term'
        />
      </AdditionalInfo.Heading>
      <RefiRequest withPrimaryButton />
      <Text size='s' paragraph>
        <FormattedMessage
          id='Homeowner.interest.refinanceInfo.description'
          defaultMessage="You're due to pay {amount} in just interest over the life of your loan. Cutting down the interest rate at the right time allows you to save money and build wealth."
          values={{
            amount: (
              <Text color='red' element='span'>
                <Format.Currency value={interestTotal} format='0,0' />
              </Text>
            )
          }}
        />
      </Text>
      <Text size='s' paragraph>
        <FormattedMessage
          id='Homeowner.interest.refinanceInfo.description2'
          defaultMessage='A few things factor into refinancing, like the costs of refinancing and your current financial situation, but oftentimes, after having paid down your loan for a while, you can get better terms because you have demonstrated reliability.'
        />
      </Text>
      <Text size='s'>
        <If condition={rates.length}>
          <FormattedMessage
            id='Homeowner.interest.refinanceInfo.rateDescription1.withRates'
            defaultMessage='The rates above are {companyName} base rates as of {now}.'
            values={{
              companyName,
              now: <Format.Date format='MMMM Do, YYYY' />
            }}
          />
        </If>
        <If condition={!rates.length}>
          <FormattedMessage
            id='Homeowner.interest.refinanceInfo.rateDescription1.withoutRates'
            defaultMessage='The rates above are estimated based on national trends and a good credit score.'
          />
        </If>{' '}
        <FormattedMessage
          id='Homeowner.interest.refinanceInfo.rateDescription2'
          defaultMessage="It's easy to get an exact number by getting a quick scenario run for you."
        />
      </Text>
      <If condition={withCurrentHomeData}>
        <Questions
          location='RefinanceCard'
          questionTopic={intl.formatMessage(QUESTIONS.refinanceTopic)}
          questions={[
            { question: intl.formatMessage(QUESTIONS.refinanceRate) },
            { question: intl.formatMessage(QUESTIONS.refinanceCost) },
            { placeholder: intl.formatMessage(QUESTIONS.placeholder) }
          ]}
        />
      </If>
    </AdditionalInfo>
  </div>
)

export default Refinance
